import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { springApi } from "./springApi";
import { sfAiDjangoApi } from "./sfAiDjangoApi";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  [springApi.reducerPath]: springApi.reducer,
  [sfAiDjangoApi.reducerPath]: sfAiDjangoApi.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
